import 'flowbite';
import { rewriteLpLinks, rewriteFormUtmInput } from './rewrite_lp'
import './home'

jQuery(function($) {
  rewriteLpLinks();
  rewriteFormUtmInput();

  var limitScrollPoint = 0;
  var spShowNavPoint = 10;
  $(window).on('load', function() {
    const windowHeight = $(window).outerHeight();
    const contentHeight = $('.main-wrapper').outerHeight();
    limitScrollPoint = contentHeight - windowHeight;

    if (is_mobile()) {
      changeFooterPadding();
    }
  });
  $(window).on('resize', function() {
    if (!is_mobile()) {
      showingButton(false);
    } else {
      changeFooterPadding();
    }
  });
  $(window).on('scroll', function() {
    var scrollPoint = $(window).scrollTop();
    // SP：少しスクロールしたら下部に申込みエリアを表示(ただしトップもしくはフッターが見える位置では非表示)
    if (is_mobile()) {
      if (scrollPoint == 0) {
        showingButton(false);
      } else if (scrollPoint >= spShowNavPoint) {
        showingButton(true);
      }
    } else {
      showingButton(false);
    }
  });

  $(window).load(function() {
    const $form = $('.js-action-form');
    // フォームの赤い枠
    if($form.length) {
      $form.each(function() {
        var $target = $(this);
        $target.change(function() {
          changeCurrentTarget($target);
        });
      });
    }
  });

  /** functions ***************************************************/
  function is_mobile() {
    const currentWidth = $(window).width();
    const spWidth = 1169;
    return currentWidth < spWidth;
  }

  function showingButton(show) {
    if (show) {
      $('#bottom_cv_area').fadeIn(1000);
    } else {
      $('#bottom_cv_area').fadeOut(1000);
    }
  }
  
  function changeFooterPadding() {
    var bannarHeight = $('#bottom_cv_area').outerHeight();
    $('#footer').css('padding-bottom', `${bannarHeight}px`);
  }

  function changeCurrentTarget($target) {
    var allSelects = $target.find('.js-form-input');
    for (let i = 0; i < allSelects.length; i++) {
      $(allSelects[i]).removeClass('current');
    }
    for (let i = 0; i < allSelects.length; i++) {
      if (allSelects[i].value === '') {
        $(allSelects[i]).addClass('current');
        return;
      }
    }
  }

  // 不動産売却向けの投稿編集ページで、監修者がまだ選択されていなかったらworth style homeを監修者に設定する
  // NOTE: 初期段階ではこの監修者が基本設定されるが、後々スケールしていった場合は別の監修者も選択されるようになっていくのでそのタイミングでこの処理は消す可能性あり
  $(window).on('load', function() {
    const isRealEstatePostOpened =
      $('#menu-posts-real-estate.wp-menu-open.menu-top').length > 0;
    if (!isRealEstatePostOpened) return;

    const selectingSupervisorCount = $('.values-list .acf-rel-item').length;
    if (selectingSupervisorCount > 0) return;

    const supervisorElementArray = $('span.acf-rel-item').get();
    const targetSupervisorElement = supervisorElementArray.find(function(
      element
    ) {
      return element.textContent.includes('worth style home');
    });
    if (targetSupervisorElement) {
      targetSupervisorElement.click();
    }
  });
  /////////////////////////////////////////////////////////////////
  // トップページ設置フォーム：ボタン型チェックボックス操作：ハピすむLPから移植
  // 単一なのでラジオボタンでも良いが今後どう変化するかわからないのでそのままで
  // チェックボックス操作
  var assetUrl = $('body').attr('data-tmpdir');
  $.fn.disableSelection = function() {
    return this.attr('unselectable', 'on')
      .css('user-select', 'none')
      .css('-moz-user-select', 'none')
      .css('-khtml-user-select', 'none')
      .css('-webkit-user-select', 'none')
      .on('selectstart', false)
      .on('contextmenu', false)
      .on('keydown', false)
      .on('mousedown', false);
  };
  $.fn.enableSelection = function() {
    return this.attr('unselectable', '')
      .css('user-select', '')
      .css('-moz-user-select', '')
      .css('-khtml-user-select', '')
      .css('-webkit-user-select', '')
      .off('selectstart', false)
      .off('contextmenu', false)
      .off('keydown', false)
      .off('mousedown', false);
  };

  // 定義：トップ項目のボタンUIがタッチのされた時に発動
  const labelStyleChange = function(e) {
    const isChecked = $(e).is(':checked');
    const checkboxId = $(e).first().attr('id');
    const $label = $(e).next();

    if (isChecked) {
      $label.css('background-color', '#f26a20');
      $label.css('color', '#ffffff');
      $label.css('background-image','-webkit-linear-gradient(top, #fa8241, rgba(242,106,32,0) 50%)');
      $label.css('background-image','-moz-linear-gradient(top, #fa8241, rgba(242,106,32,0) 50%)');
      $label.css('background-image','-o-linear-gradient(top, #fa8241, rgba(242,106,32,0) 50%)');
      $label.css('background-image','-ms-linear-gradient(top, #fa8241, rgba(242,106,32,0) 50%)');
      $label.css('background-image','-linear-gradient(top, #fa8241, rgba(242,106,32,0) 50%)');
      $label.addClass('selected_label');
      if (checkboxId === 'step1_choices_1st') {
        $label.css('background-image','url(' + assetUrl + 'img/icon_step1_house_checked.png)');
      } else if (checkboxId === 'step1_choices_2nd') {
        $label.css('background-image','url(' + assetUrl + 'img/icon_step1_mansion_checked.png)');
      } else if (checkboxId === 'step1_choices_3rd') {
        $label.css('background-image','url(' + assetUrl + 'img/icon_step1_shop_checked.png)');
      }
      $label.css('border', '1px solid rgb(242, 106, 32)');
    } else {
      $label.css('background-color', '');
      $label.css('color', '');
      $label.css('background-image', '');
      $label.css('border', '1px solid #626262');
      $label.removeClass('selected_label');
    }
    return true;
  };

  $('#top-form')
    .find('input[type="checkbox"]')
    .change(function() {
      // トップ項目のボタンUIがタッチされた時に発動
      labelStyleChange($(this));
    });

  $('.chk_single_select').on('click', function() {
    $('.chk_single_select')
      .prop('checked', false)
      .change(); //  全部のチェックを外す
    $(this)
      .prop('checked', true)
      .change(); //  押したやつだけチェックつける
  });

  $('#js__sideMenuBtn').on('click', function () {
    $('body').toggleClass('side-open');
    return false;
  });

  $('#js__overlay, .side-menu .close').on('click', function () {
    $('body').removeClass('side-open');
    return false;
  });

  $('#acdn-button, #acdn-button-close').click(function () {
    $('#acdn-target').slideToggle();
    return false;
  });

  $('a[href^="#"]').click(function () {
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var headerHeight = 105; //固定ヘッダーの高さ
    var position = target.offset().top - headerHeight; //ターゲットの座標からヘッダの高さ分引く
    $('body,html').animate({scrollTop: position}, speed, 'swing');
    return false;
  });

  // sp用都道府県選択エリア
  $('.js-region-select ._toggle').click(function() {
    var $this = $(this);
    var selected = $this.attr('id').replace('js-region-', '');
    var $list = $('.js-region-frame');

    $list.find('#js-pref-' + selected).css('display', 'flex'); 
    $list.addClass('is-next');
  });

  $('#js-region-back').click(function() {
    $('.sp-region-frame').removeClass('is-next');
    $('.js-pref-list ._pref').css('display', 'none');
  });

  // リフォーム記事ページのスライダー
  $('.slider').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    prevArrow: '<button type="button" class="slide-arrow prev-arrow">',
    nextArrow: '<button type="button" class="slide-arrow next-arrow">',
    responsive: [
      {
        breakpoint: 640,
        settings: {
        slidesToShow: 1,
        },
      },
    ],
  });

  $('.single-reform-case__main-image-slider').slick({
    prevArrow: '<button type="button" class="slide-arrow prev-arrow">',
    nextArrow: '<button type="button" class="slide-arrow next-arrow">',
    asNavFor: ".single-reform-case__thumbnail-image-slider",
  });

  $('.single-reform-case__thumbnail-image-slider').slick({
    speed: 300,
    slidesToShow: 4,
    prevArrow: '<button type="button" class="slide-arrow prev-arrow">',
    nextArrow: '<button type="button" class="slide-arrow next-arrow">',
    asNavFor: ".single-reform-case__main-image-slider",
    focusOnSelect: true,
  });

  $(".magnifiable-img").click(function () {
    $("#magnified-img-modal").html($(this).children('picture').prop("outerHTML"));
    // data-srcsetの中の最適な画像を表示させるためにリサイズイベントを発火
    window.dispatchEvent(new Event('resize'));
    $("#magnified-img-modal").fadeIn(200);
    return false;
  });

  $("#magnified-img-modal").click(function () {
    $("#magnified-img-modal").fadeOut(200);
    return false;
  });

  $('.js-review-note').hover(function() {
    $('.js-review-popup').fadeIn();
  }, function() {
    $('.js-review-popup').fadeOut();
  });

  $('#order-button').click(function(event) {
    event.stopPropagation();
    $(this).next('div[role="menu"]').toggle();
  });
});
